import React, { useEffect, useState } from "react"
import axios from "axios"
import { XMLParser } from "fast-xml-parser" // Import XML parsing library
import Grid from "../grid/grid.js"
import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"

const OpenPositions = ({ blok }) => {
  const [fetchContent, setFetchContent] = useState(false)
  const [gridBlok, setGridBlok] = useState({
    ...blok,
    class: "open_positions",
    grid_items: [],
  })

  useEffect(() => {
    if (
      typeof window == "undefined" ||
      window.parent.location !== window.location
    ) {
      // You are in Draft Mode or in the Visual Editor. Skip animation.
      return
    }

    if (!gridBlok.grid_items?.length) {
      gsap.registerPlugin(ScrollTrigger)
      return
    }

    // Content reveal.
    ScrollTrigger.batch(".open_positions .gs_reveal", {
      onEnter: el => gsap.set(el, { stagger: 0.2, attr: { in: 1 } }),
      onLeaveBack: el => gsap.set(el, { attr: { in: 0 } }),
    })
  }, [gridBlok])

  useEffect(() => {
    // Make the API call using Axios
    if (!fetchContent) {
    axios
      .get("https://api.lever.co/v0/postings/zignallabs?mode=xml")
      .then(response => {
        // Parse the XML data using the fast-xml-parser library
        const parser = new XMLParser()
        const jsonData = parser.parse(response.data);

        let grid_items = null;

        if (jsonData.jobs?.job) {
          // Check if jsonData.jobs.job is array or a single object.
          const multipleJobs = Array.isArray(jsonData.jobs.job)
          const jobs = multipleJobs ? jsonData.jobs.job : [jsonData.jobs.job]

          // Handle the parsed XML data and update the state with the converted data
          grid_items = jobs.map((job, index) => ({
            _uid: `${blok._uid}_${index}`,
            grid_content: [
              {
                _uid: job.id,
                component: "position",
                cta_text: blok.cta_text,
                ...job,
              },
            ],
          }))
        }

        setFetchContent(true)
        setGridBlok({ ...gridBlok, grid_items })
      })
      .catch(error => {
        console.error("Error fetching data from XML feed:", error)
      })
    }
  }, [blok, gridBlok, fetchContent])

  return <Grid blok={gridBlok} />
}

export default OpenPositions
